export default class ResourcesDispatcher {
    private static _SPINES: any;
    private static _SOUNDS: any;
    private static _ATLAS: any;
    private static _GAME_CONSTANTS: any;

    static loadResources(spines: any, atlas: any, sounds: any, game_constants: any): void {
        this._SPINES = spines;
        this._ATLAS = atlas;
        this._SOUNDS = sounds;
        this._GAME_CONSTANTS = game_constants;

        console.log("Resources loaded into ResourcesDispatcher");
    }

    static get SPINES(): any {
        return this._SPINES;
    }

    static get ATLAS(): any {
        return this._ATLAS;
    }

    static get SOUNDS(): any {
        return this._SOUNDS;
    }

    static get GAME_CONSTANTS(): any {
        return this._GAME_CONSTANTS;
    }
}